'use client';

import { ActionIcon, Menu } from '@mantine/core';
import {
  IconHeart,
  IconLogout,
  IconRosetteDiscountCheck,
  IconTruck,
  IconUser,
} from '@tabler/icons-react';
import { useMutation } from '@tanstack/react-query';
import { setToken } from '@website/server/actions/auth';
import { useTranslations } from 'next-intl';
import Link from 'next/link';

export function UserButton({
  authed,
  onModalOpen,
}: {
  authed: boolean;
  onModalOpen: () => void;
}) {
  const t = useTranslations();

  const logoutMut = useMutation({
    mutationFn: () => setToken(''),
    onSuccess: () => {
      window.location.href = '/login';
    },
  });

  if (!authed) {
    return (
      <ActionIcon size="xl" variant="light" onClick={onModalOpen}>
        <IconUser />
      </ActionIcon>
    );
  }

  return (
    <Menu withArrow>
      <Menu.Target>
        <ActionIcon size="xl" variant="light">
          <IconUser />
        </ActionIcon>
      </Menu.Target>

      <Menu.Dropdown miw={180}>
        <Menu.Item
          component={Link}
          href="/profile"
          leftSection={<IconUser size={20} stroke={1.5} />}
        >
          {t('profile.profile')}
        </Menu.Item>

        <Menu.Item
          component={Link}
          href="/orders"
          leftSection={<IconTruck size={20} stroke={1.5} />}
        >
          {t('profile.orders')}
        </Menu.Item>

        <Menu.Item
          component={Link}
          href="/favorites"
          leftSection={<IconHeart size={20} stroke={1.5} />}
        >
          {t('profile.favorites')}
        </Menu.Item>

        <Menu.Item
          href="/warranty"
          component={Link}
          leftSection={<IconRosetteDiscountCheck size={20} stroke={1.5} />}
        >
          {t('profile.warranty')}
        </Menu.Item>

        <Menu.Item
          color="red"
          onClick={() => logoutMut.mutate()}
          leftSection={<IconLogout size={20} stroke={1.5} />}
        >
          {t('profile.logout')}
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
